import { render, staticRenderFns } from "./TablePlantaoFerias.vue?vue&type=template&id=7a6de9fa"
import script from "./TablePlantaoFerias.vue?vue&type=script&lang=js"
export * from "./TablePlantaoFerias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports